import store from "../../../store";
import rappi_export from './rappi_export.vue';

window.rappi_export =  new Vue({
    store,
    el: 'div#rappi_export',

    name : "rappi_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        rappi_export,
    }
});
